import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  mainDialog: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    minWidth: '991px',
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    direction: 'rtl',
  },
  footer: {
    display: 'flex',
    gap: '1rem',
  },

  cardContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    borderRadius: '0.75rem',
    border: '1px solid #DCDFE1',
    padding: '1rem',
  },
}));

export default useStyles;
